
        Component.define('filter-vehicle', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $btnFilter      = $('.brand .radio-default')

// if($(this).attr('checked')) {
//     $('.products').hide();
// }


$el.find('.select2').select2();

$el.on('contentLoaded', function(){
});

$el.on('submit', function(evt, dataForm){
    let $form = $el.find('.filter-form');
    let url = $form.attr('action');
    let $containerPosts = $el.closest('main').find('.wrap-boxes');
    let $btnLoadMore = $el.closest('main').find('.latest-news .btn-load-more');

    loading.show();

    console.log(dataForm);



    $.ajax({
        method: "get",
        data: dataForm,
        url: url
    }).done(function( data ) {
        $containerPosts.empty();

        setTimeout(function(){
            loading.hide();
            $el.trigger('contentLoaded');
            $el.closest('main').find('.wrap-boxes').append(data.html);
            window.SvgFix();
            $window.trigger('scroll');


            if(!data.year){
                $('[name=year]').empty();

                $('[name=year]').append('<option value="">Filtrar por ano</option>');
                data.years.forEach(function(year){
                    $('[name=year]').append('<option value="'+year+'">'+year+'</option>');
                });
            }

            $('[name=year] option[value="'+data.year+'"]').attr('selected', 'selected');


            if(data.nextPageUrl){
                $btnLoadMore.show();
                $btnLoadMore.attr('href', data.nextPageUrl);
            } else {
                $btnLoadMore.hide();
            }

            if(data.products.length > 0){
                $el.find('.wrap-filter-block.product').fadeIn();
                let containerProds = $el.find('.wrap-filter-block.product ul');
                containerProds.empty();
                $('[name="product_mobile[]"]').empty();
                data.products.forEach(function(product){
                    let html = `<label class="radio-button-default">
                                    <input class="radio-default" type="checkbox" name="product[]" value="${product.id}">
                                    <span class="text-radio">${product.name}</span>
                                </label>`;
                    containerProds.append(html);
                    $('[name="product_mobile[]"]').append('<option value="'+product.id+'">'+product.name+'</option>');
                });
            }

        }, 1000);
    }).fail(function(){
        alert('erro');
    });
});

$btnFilter.on('change', function(){
    if($(this).hasClass('activeFilter')){
        return;
    }

    $el.find('.wrapper-vehicles input').not(this).prop('checked', false);
    $('[data-component="filter-vehicle"]').find('[name=year]').val('');

    $(this).addClass('activeFilter');
    $btnFilter.not(this).removeClass('activeFilter');
});

$el.find('[name=brand]').on('change', function(e){
    let $form = $el.find('.filter-form');
    data = [];
    data.push({ name: 'year', value: null });
    data.push({ name: 'categoria', value: $el.find('[name=categoria]').val() });
    data.push({ name: 'brand', value: $(this).val() });
    data.push({ name: 'input', value: 'brand' });

    console.log(data);

   $el.trigger('submit', [Object.assign(data)]);
});


$body.on('change', '[name="product[]"]', function(e){
    let data = [];
    data.push({ name: 'year', value: null });
    data.push({ name: 'categoria', value: $el.find('[name=categoria]').val() });
    data.push({ name: 'brand', value: $el.find('[name=brand]:checked').val() });
    $el.find('[name="product[]"]:checked').each(function(){
        data.push({ name: 'product[]', value: $(this).val() });
    });
    data.push({ name: 'input', value: 'product' });

    console.log(data);

   $el.trigger('submit', [Object.assign(data)]);
});

$body.on('change', '[name="product_mobile[]"]', function(e){
    let data = [];
    data.push({ name: 'year', value: null });
    data.push({ name: 'categoria', value: $el.find('[name=categoria]').val() });
    data.push({ name: 'brand', value: $el.find('[name=brand_mobile]').val() });
    $('[name="product_mobile[]"]').val().forEach(function(product){
        data.push({ name: 'product[]', value: product });
    });
    data.push({ name: 'input', value: 'product' });

    console.log(data);

   $el.trigger('submit', [Object.assign(data)]);
});


$body.on('change', '[name="brand_mobile"]', function(e){
    let data = [];
    data.push({ name: 'year', value: null });
    data.push({ name: 'categoria', value: $el.find('[name=categoria]').val() });
    data.push({ name: 'brand', value: $el.find('[name=brand_mobile]').val() });
    $('[name="product_mobile[]"]').val().forEach(function(product){
        data.push({ name: 'product[]', value: product });
    });
    data.push({ name: 'input', value: 'brand' });

    console.log(data);

   $el.trigger('submit', [Object.assign(data)]);
});


$el.find('[name=year]').on('change', function(){
    let val = $(this).val();
    $('[data-component="filter-vehicle"]').find('[name=year]').val(val);

    let data = [];
    data.push({ name: 'year', value: $(this).val() });
    data.push({ name: 'categoria', value: $('[name=categoria]').val() });
    data.push({ name: 'brand', value: $el.find('[name=brand_mobile]').val() });
    $('[name="product_mobile[]"]').val().forEach(function(product){
        data.push({ name: 'product[]', value: product });
    });
    data.push({ name: 'input', value: 'year' });

    console.log(data);

    $el.trigger('submit', [Object.assign(data)]);
});

        });